<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <!--        <el-select v-model="queryParam.batchId" @change="getSpecialtyList" placeholder="选择考试" filterable style="width:200px;margin-right:10px;">-->
        <!--          <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>-->
        <!--        </el-select>-->
        <!--        <el-select v-model="queryParam.specialtyId" placeholder="所属专业" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">-->
        <!--          <el-option v-for="(item,index) in specialtyList" :key="index" :label="item.specialtyName" :value="item.specialtyId" :class="item.disabled?'none':''"></el-option>-->
        <!--        </el-select>-->
        <!--        <el-select v-model="queryParam.agentId" placeholder="承办单位" @change="getPage({pageNum: 1})" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">-->
        <!--          <el-option v-for="(item,index) in agentList" :key="index" :label="item.agentName" :value="item.agentId" :class="item.disabled?'none':''"></el-option>-->
        <!--        </el-select>-->
        <el-select v-model="queryParam.compareType" placeholder="比对类型" filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.faceCompareStatus)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeName" clearable placeholder="考生姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;margin-bottom: 10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.examineeIdNo" clearable placeholder="证件号"></el-input>
        <el-select v-model="queryParam.isSolve" placeholder="审核状态" clearable filterable style="width:200px;margin-right:10px;margin-bottom: 10px;">
          <el-option v-for="(item,index) in Tool.map2arr($enums.IsSolve)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
        </el-select>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
        <el-button @click="queryParam=JSON.parse(JSON.stringify(oldQueryParam)),getPage({pageNum: 1}),getSpecialtyList()" type="default">重置</el-button>
      </div>
    </div>
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page.list" stripe :height="tableHeight" size="medium" @selection-change="multipleSelection=$event">
        <el-table-column prop="examineeName" label="姓名">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye2">
              <span>{{scope.row.examineeName}}</span>
              <i v-if="scope.row.examineeName" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye2">
              <span>{{scope.row.examineeName2}}</span>
              <i v-if="scope.row.examineeName2" style="margin-left: 5px;" class="el-icon-view" @click="reloadName(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="categoryName" label="所属分类"></el-table-column>
        <el-table-column prop="specialtyName" label="所属专业">
          <template slot-scope="scope">
            {{scope.row.specialtyName}}-{{scope.row.gradeName}}
          </template>
        </el-table-column>
        <el-table-column prop="compareType" label="比对类型">
          <template slot-scope="scope">
            {{$enums.faceCompareStatus[scope.row.compareType]}}
          </template>
        </el-table-column>
        <el-table-column prop="examineeIdNo" label="证件号">
          <template slot-scope="scope">
            <span v-show="!scope.row.trueEye">
              <span>{{scope.row.examineeIdNo}}</span>
              <i v-if="scope.row.examineeIdNo" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
            </span>
            <span v-show="scope.row.trueEye">
              <span>{{scope.row.examineeIdNo2}}</span>
              <i v-if="scope.row.examineeIdNo2" style="margin-left: 5px;" class="el-icon-view" @click="reloadIdNo(scope.$index, scope.row)"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="agentName" label="承办单位"></el-table-column>
        <el-table-column prop="signTime" label="上传时间">
          <template slot-scope="scope">
            {{scope.row.addTime?$moment(scope.row.addTime).format('YYYY-MM-DD HH:mm:ss'):''}}
          </template>
        </el-table-column>
        <el-table-column prop="isSolve" label="审核状态">
          <template slot-scope="scope">
            {{$enums.IsSolve[scope.row.isSolve]}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="edit(scope.row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog :title="(editForm.row?'查看':'创建')+editForm.title" v-if="editForm.show" :visible.sync="editForm.show" width="800px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage()" style="max-height: 500px;overflow-y: auto;"></Edit>
    </el-dialog>
  </div>
</template>
<script>
import Edit from '../face-edit'

export default {
  name: 'examineeFace',
  components: { Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { batchId: this.$route.query.batchId },
      oldQueryParam: {},
      page: { pageSize: 20, pageNum: 1 },
      multipleSelection: [],
      editForm: { show: false, row: null, title: '详情' },
      batchList: [],
      specialtyList: [],
      agentList: []
    }
  },
  async created () {
    // this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    // if (this.Tool.isNull(this.batchList)) {
    //   throw new Error('没有考试数据')
    // }
    // if (!this.queryParam.batchId) {
    //   this.queryParam.batchId = this.batchList[0].batchId
    // }
    // await this.getSpecialtyList()
    await this.getPage()
    this.oldQueryParam = JSON.parse(JSON.stringify(this.queryParam))
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getSpecialtyList (event) {
      this.specialtyList = await this.$HTTP.ApiSpecialty.getList({ batchId: this.queryParam.batchId })
      this.agentList = await this.$HTTP.ApiBatch.getAgentList(this.queryParam.batchId)
      if (event) {
        this.queryParam.specialtyId = ''
        this.queryParam.agentId = ''
      }
      await this.getPage()
    },
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        this.editForm.row = null
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiFaceCertify.getPage(this.queryParam)
        if (page.list) {
          page.list.map(el => {
            this.$set(el, 'examineeIdNo2', el.examineeIdNo)
            this.$set(el, 'examineeName2', el.examineeName)
            this.$set(el, 'trueEye2', true)
            this.$set(el, 'trueEye', true)
            // el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            // el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            if (el.examineeIdNo) {
              el.examineeIdNo2 = el.examineeIdNo.replace(/^(.{6})(?:\w+)/, "\$1********")
            }
            if (el.examineeName) {
              el.examineeName2 = el.examineeName.replace(/(?<=.)./g, '*')
            }
          })
        }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async reloadIdNo (index, row) {
      if (row.trueEye == true) {
        this.$set(row, 'trueEye', false)
      } else {
        this.$set(row, 'trueEye', true)
      }
    },
    async reloadName (index, row) {
      if (row.trueEye2 == true) {
        this.$set(row, 'trueEye2', false)
      } else {
        this.$set(row, 'trueEye2', true)
      }
    },
    async edit (row) {
      this.editForm.show = true
      if (row) {
        this.editForm.row = row
      } else {
        this.editForm.row = null
      }
    }
  }
}
</script>
